export enum InvoiceStatus {
  All = 'all',
  Credited = 'credited',
  Draft = 'draft',
  Overdue = 'overdue',
  Unpaid = 'unpaid',
  Paid = 'paid',
  PartiallyCredited = 'partially_credited',
  PartiallyPaid = 'partially_paid',
}
